import React from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { Alert, AlertLink } from 'localmed-core';

import { Input } from '../../../legacyCore/Form';

export default class EmailInput extends React.Component {
  static propTypes = {
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    validateEmail: PropTypes.func,
    onValidate: PropTypes.func,
    onClickDidYouMean: PropTypes.func,
    validationResult: PropTypes.shape({
      didYouMean: PropTypes.string,
    }),
    // eslint-disable-next-line react/forbid-prop-types
    validateEmailResult: PropTypes.object,
  };

  static contextTypes = {
    formik: PropTypes.shape({
      handleBlur: PropTypes.func.isRequired,
      handleChange: PropTypes.func.isRequired,
    }),
  };

  onBlur = (event) => {
    this.validateEmail(event.target.value);
    if (this.props.onBlur) {
      this.props.onBlur(event);
    } else if (this.context.formik) {
      this.context.formik.handleBlur(event);
    }
  };

  onChange = (event) => {
    if (this.props.onValidate) {
      this.props.onValidate(null);
    }
    if (this.props.onChange) {
      this.props.onChange(event);
    } else if (this.context.formik) {
      this.context.formik.handleChange(event);
    }
  };

  onClickDidYouMean = () => {
    // istanbul ignore next
    if (this.inputNode) {
      this.inputNode.focus();
    }
    if (this.props.onValidate) {
      this.props.onValidate(null);
    }
    if (this.props.onClickDidYouMean) {
      this.props.onClickDidYouMean(this.props.validationResult.didYouMean);
    }
  };

  setInputRef = (node) => {
    // istanbul ignore next
    this.inputNode = node;
  };

  async validateEmail(email) {
    const { onValidate } = this.props;
    if (!onValidate) {
      return;
    }
    // If the email doesn't pass a simple format check, we’ll skip calling the API to validate,
    // which is mostly useful for verifying the existence of the actual email address.
    const errors = validate.single(email, { email: true });
    if (errors) {
      return;
    }
    // If there are any errors or no results just fail silently as we don't want this preventing
    // an appointment from being scheduled
    let result;
    try {
      result = await this.props.validateEmail({ variables: { email } });
    } catch (error) {
      return;
    }
    const { data } = result;
    if (!data) {
      return;
    }
    onValidate(data.validateEmail);
  }

  render() {
    const {
      validateEmail,
      validationResult,
      onValidate,
      onClickDidYouMean,
      validateEmailResult,
      ...props
    } = this.props;
    return (
      <React.Fragment>
        <Input
          type="email"
          {...props}
          onBlur={this.onBlur}
          onChange={this.onChange}
          ref={this.setInputRef}
        />
        {validationResult && validationResult.didYouMean && (
          <Alert tier="warning" subtle fontSize="xs" marginTop="xs">
            Did you mean{' '}
            <AlertLink onClick={this.onClickDidYouMean}>{validationResult.didYouMean}</AlertLink>?
          </Alert>
        )}
      </React.Fragment>
    );
  }
}
